export const styles = () => ({
  attributeNameWrap: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: 38,
    minWidth: 79,
  },
  inputWrap: {
    width: '100%',
    position: 'relative',
    display: 'inline-block',
  },
  attributeName: {
    backgroundColor: '#5A98F7',
    color: '#ffffff',
    borderRadius: 50,
    padding: '1px 8px',
    fontSize: 14,
    height: 24,
    width: 'fit-content',
    margin: 0,
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  button: {
    fontSize: 14,
    color: '#1658F3',
    padding: '8px 0px',
    borderTop: '1px solid rgba(53, 64, 82, 0.1)',
    textAlign: 'center',
    cursor: 'pointer',
  },
  addAttibute: {
    padding: '8px 12px',
    backgroundColor: 'rgba(90, 152, 247, 0.1)',
    cursor: 'pointer',
  },
  optionTitle: {
    color: 'rgba(53, 64, 82, 0.7)',
    fontSize: 14,
    margin: 0,
    textAlign: 'start',
  },
  option: {
    margin: '4px 0px 0px',
    color: '#ffffff',
    padding: '1px 8px',
    borderRadius: 50,
    width: 'fit-content',
    fontSize: 14,
    cursor: 'pointer',
    backgroundColor: '#5A98F7',
  },
  customOption: {
    color: '#ffffff',
    borderRadius: 50,
    padding: '1px 8px',
    height: 24,
    width: 'fit-content',
    margin: '5px 12px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  tooltip: {
    boxSizing: 'border-box',
    boxShadow: '4px 4px 29px rgba(19, 69, 186, 0.0855129)',
    borderRadius: '10px',
    zIndex: 9999,
    opacity: 1,
    textAlign: 'start',
    fontWeight: 'normal',
    padding: 10,
    backgroundColor: '#616581',
  },
})

export const customStyles = (required, styles) => ({
  control: (provided, state) => {
    const error =
      required &&
      !state.hasValue &&
      !state.isFocused &&
      state.selectProps.touched

    return {
      ...provided,
      ...styles,
      width: '100%',
      border: error ? '1px solid red' : '1px solid #D7D8DF',
      outline: 'none',
      boxShadow: 'none',
      '&:hover': {
        border: error ? '1px solid red' : '1px solid rgba(53, 64, 82, 0.5)',
        boxShadow: 'none',
      },
    }
  },
  indicatorSeparator: (provided, state) => ({
    ...provided,
    backgroundColor: '#ffffff',
    display: 'none',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: '#354052',
    fontSize: 14,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#ffffff',
    display: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: '#ffffff',
    },
  }),
  groupHeading: base => ({
    ...base,
    color: '#354052',
    fontSize: 14,
    textTransform: 'none',
  }),
  option: (provided, state) => {
    return {
      ...provided,
      fontSize: 14,
      cursor: 'pointer',
      padding: '2px 0px',
      backgroundColor: state.isFocused ? '#dfecff' : '#ffffff',
      width: '100%',
      overflowX: 'hidden',
      '&:hover': {
        fontSize: 14,
        backgroundColor: state.isFocused ? '#dfecff' : '#ffffff',
      },
    }
  },
  menu: (provided, state) => ({
    ...provided,
    width: '100%',
    minWidth: 200,
    maxHeight: 250,
    padding: 0,
  }),
  menuList: provided => ({
    ...provided,
    padding: 0,
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: 200,
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: 'rgba(53, 64, 82, 0.5)',
    fontSize: 14,
    width: 'max-content',
  }),
  noOptionsMessage: provided => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  clearIndicator: provided => ({
    ...provided,
    display: 'none',
  }),
})
